import { render, staticRenderFns } from "./SocialNavLinks.vue?vue&type=template&id=67e87232&"
import script from "./SocialNavLinks.vue?vue&type=script&lang=js&"
export * from "./SocialNavLinks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports